<nav #navbar class="navbar navbar-expand-lg navbar-transparent  navbar-absolute" *ngIf="isUser()">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </button>
      </div>
      <!--       <a class="navbar-brand" href="{{getPath()}}"> {{getTitle()}}</a>
 -->
    </div>
    <button mat-button class="navbar-toggler btn-no-ripple" type="button" (click)="sidebarToggle()">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navigation">

      <ul class="navbar-nav">

        <li class="nav-item dropdown">
          
          <a *ngIf="!isAsociadoPre" class="nav-link" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i class="material-icons iconTheme">email</i>
            <span class="notification">1</span>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
            <i class="material-icons iconTheme" style="margin-left: 15px;">notifications</i>
            <span class="notification">0</span>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
           
          </a>
       
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">

          </div>
        </li>
        
        <li class="nav-item dropdown">
        
            <a class="nav-link" href="#" id="navbarDropdownMenuUser" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <div style="display: flex; height: auto;">
                <div style="margin-right: 11px;">
                  <div class="badge"></div>
                </div>
                <div style="display: flex;align-items: center; justify-content: center;">
                  <label> {{dataUser.Nombre+ " "+ dataUser.Apellidos}}</label>
                </div>
              </div>
         
         
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuUser">
              <a *ngIf="isAsociado" class="dropdown-item" (click)="ValidChangePassword()">
                <i class="fa fa-refresh"> </i>&nbsp; Cambiar Contraseña</a>
              <a class="dropdown-item" routerLink="/publico/Logout">
                <i class="fa fa-sign-out fa-fw"> </i>&nbsp; Salir</a>
  
            </div>
       
        
        </li>
      </ul>
    </div>
  </div>
</nav>